import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Privacy() {
  return <div className="pt-0 bg-warmwhite min-h-screen" data-id="element-1072" data-mp="2wkq9omfllvjr">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-navy overflow-hidden" data-id="element-1073" data-mp="3b8tdpqa2yx5x">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-1074" data-mp="36huvum9g1r0k" />
        <div className="container relative z-10 mx-auto px-6 md:px-12 text-center" data-id="element-1075" data-mp="3k8gh2hmded1m">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1076" data-mp="3faeuvntndxlx">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-1077" data-mp="3u5cpyog6l16p">
              Privacy Policy
            </h1>
            <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-1078" data-mp="1zt4t35kaua8a">
              How we collect, use, and protect your personal information.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 lg:py-16" data-id="element-1079" data-mp="h3h4hzodcaxh">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-1080" data-mp="h0ctojgeegxu">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-softgray prose prose-lg prose-slate max-w-none" data-id="element-1081" data-mp="l4aqgni93fnq">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1082" data-mp="q11a1kt9ktdw">1. Data Collection Practices</h2>
            <p className="text-mediumgray mb-8" data-id="element-1083" data-mp="uvf8xx74xinb">
              We collect information you provide directly to us when you make a donation, sign up for our newsletter, register for an event, or communicate with us.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1084" data-mp="18su3fgc8wgm5">2. Data Usage & Protection</h2>
            <p className="text-mediumgray mb-8" data-id="element-1085" data-mp="1dsyir31f35as">
              We use the information we collect to process transactions, send you updates, and improve our platform. We implement appropriate security measures to protect your personal information.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1086" data-mp="3flw7amo5vbpx">3. Cookies Policy</h2>
            <p className="text-mediumgray mb-8" data-id="element-1087" data-mp="mpl6qy6aal2v">
              Our website uses cookies to enhance your browsing experience, analyze site traffic, and serve targeted advertisements. You can control cookie settings through your browser.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1088" data-mp="qqet3n42vrtn">4. Third-Party Sharing</h2>
            <p className="text-mediumgray mb-8" data-id="element-1089" data-mp="15nximroky925">
              We do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1090" data-mp="1eibtmi22uxfg">5. User Rights</h2>
            <p className="text-mediumgray mb-8" data-id="element-1091" data-mp="1afp8t13tqcrr">
              You have the right to access, correct, or delete your personal data. If you wish to exercise these rights, please contact our support team.
            </p>

            <div className="mt-12 pt-8 border-t border-softgray" data-id="element-1092" data-mp="1jdr3z00vmb74">
              <p className="text-sm text-mediumgray" data-id="element-1093" data-mp="231x2ssxys2rz">
                Last updated: July 2026. For privacy-related inquiries, please <Link to="/contact" className="text-gold hover:underline" data-id="element-1094" data-mp="27ye28jam63kd">contact us</Link>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}